import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectTabs = ({ activeTab, onTabChange, ongoingCount, completedCount, draftCount }) => {
  const tabs = [
    {
      id: 'ongoing',
      label: 'Ongoing Projects',
      icon: 'FolderOpen',
      count: ongoingCount
    },
    {
      id: 'completed',
      label: 'Completed Projects',
      icon: 'FolderCheck',
      count: completedCount
    },
    {
      id: 'drafts',
      label: 'Drafts',
      icon: 'Bot',
      count: draftCount
    }
  ];

  return (
    <div className="bg-card border-b border-border">
      <div className="flex items-center gap-2 px-4 md:px-6 lg:px-8 overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center gap-2 px-4 py-4 border-b-2 transition-smooth min-h-[56px] whitespace-nowrap ${
              activeTab === tab?.id
                ? 'border-primary text-primary font-semibold' :'border-transparent text-muted-foreground hover:text-foreground font-medium'
            }`}
          >
            <Icon
              name={tab?.icon}
              size={20}
              strokeWidth={activeTab === tab?.id ? 2.5 : 2}
            />
            <span className="text-base">{tab?.label}</span>
            <span
              className={`flex items-center justify-center min-w-[24px] h-6 px-2 rounded-full text-xs font-semibold ${
                activeTab === tab?.id
                  ? tab?.id === 'drafts' ?'bg-amber-100 text-amber-700' :'bg-primary/10 text-primary' :'bg-muted text-muted-foreground'
              }`}
            >
              {tab?.count ?? 0}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProjectTabs;